import { BaseService } from "./base.service";
import { ITitle } from "models/TitleModel";

class UserTitleServiceInternal extends BaseService {
	getTitleList = async (): Promise<ITitle[]> =>
		this.callApi<ITitle[]>(
			`UserTitle/GetUserTitleList`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			false
		);
}

export const UserTitleService = new UserTitleServiceInternal();
